export class CountyItem {
    constructor(data) {
        this.countyId = data.countyId;
        this.countyName = data.countyName;
    }
}